export default "__VITE_ASSET__Bhv61e_L__"